module.exports = __webpack_public_path__ + "static/media/Spinda_gaussian2.40163224.png";